/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

export default [
  {
    path: '/',
    name: 'home.index',
    component: () => import('../views/home/Index'),
  },
  {
    path: '/usage',
    name: 'usage.index',
    component: () => import('../views/usage/Index'),
  },
  {
    path: '/streamer',
    name: 'streamer.index',
    component: () => import('../views/streamer/Index'),
  },
  {
    path: '/streamer/:id',
    name: 'streamer.detail',
    component: () => import('../views/streamer/Detail'),
  },
  {
    path: '/news',
    name: 'news.index',
    component: () => import('../views/news/Index'),
  },
  {
    path: '/news/:id',
    name: 'news.detail',
    component: () => import('../views/news/Detail'),
  },
  {
    path: '/faq',
    name: 'faq.index',
    component: () => import('../views/faq/Index'),
  },
  {
    path: '/faq/:id',
    name: 'faq.detail',
    component: () => import('../views/faq/Detail'),
  },
  {
    path: '/contact',
    component: () => import('../views/contact/Base'),
    children: [
      {
        path: '',
        name: 'contact.index',
        component: () => import('../views/contact/Index'),
      },
      {
        path: 'confirm',
        name: 'contact.confirm',
        component: () => import('../views/contact/Confirm'),
      },
      {
        path: 'complete',
        name: 'contact.success',
        component: () => import('../views/contact/Success'),
      }
    ]
  },
  // {
  //   path: '/company',
  //   name: 'company.index',
  //   component: () => import('../views/company/Index'),
  // },
  {
    path: '/terms',
    name: 'terms.index',
    component: () => import('../views/termsService/Index'),
  },
  {
    path: '/policy',
    name: 'policy.index',
    component: () => import('../views/privacyPolicy/Index'),
  },
  {
    path: '/tradelaw',
    name: 'tradelaw.index',
    component: () => import('../views/tradelaw/Index'),
  },
  {
    path: '*',
    name: '404',
    component: () => import('../views/errors/404'),
  }
]
